<template>
    <div>
        <div style="">
            <a-button class="top_btn" type="primary"
                      @click="()=>{visibleForm = true; titleForm='添加分类'; this.editId=''; }"   > 添加分类
            </a-button>
            <a-button class="top_btn" type="primary" @click="listOrder()"  > 排序</a-button>
            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="start"
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button type="primary" :disabled="!hasSelected" :loading="loading"   >
                    删除
                </a-button>
            </a-popconfirm>

            <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>
        <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :columns="columns"
                :data-source="data"
                :loading="loading"
                rowKey="id"
                :pagination="pagination"
        >
        <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
          <span slot="name" slot-scope="text, record">
            <p style="word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;" :title="text">{{text}}</p>
      </span>
          <span slot="status" slot-scope="text, record">
                <a-switch
                    @click="onChange(record)"
                    :checked="text == 1 ? true : false"
                />
            </span>
            <span slot="action" slot-scope="text, record">
        <a @click="(record)=>{visibleForm = true; titleForm='修改友情链接',editId=text.id ; }"  >编辑<a-divider type="vertical"/></a>

          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}">
   <a  >删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <LinksForm :visible="visibleForm" :title="titleForm" :editId="editId"
                   @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "></LinksForm>
    </div>
</template>

<script>
    import LinksForm from "./components/linksForm";
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "排序",
            dataIndex: "list_order",
            key: "list_order",
            width: "18%",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "分类名称",
            dataIndex: "name",
            // ellipsis: true,
            key: "name",
            width: "18%",  scopedSlots: {customRender: "name"}
        },
      {
        title: "状态",
        dataIndex: "status",
        ellipsis: true,
        key: "status",
        scopedSlots: {customRender: "status"}
      },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    const data = [];

    export default {
        name: "index",
        data() {
            return {
                current: 1,
                visibleForm: false,
                titleForm: "",
                editId: null,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                sortLists: []
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ksh/ModuleCategory"; //设置左侧导航2-2 active
        },
        components: {LinksForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        mounted() {
            this.getList()
        },
        methods: {
            getList(page) {
                this.loading = true;
                API.link.GET_LIST(page || 1).then(res => {
                    this.pagination.total = res.data.data.list.total
                    this.pagination.pageSize = res.data.data.list.per_page
                    this.pagination.current = res.data.data.list.current_page
                    this.data = res.data.data.list.data
                    this.loading = false
                })
            },
            getchangId(data) {
                this.sortLists=[]
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < data.length; i++) {
                    sortListOrder.id = data[i].id
                    sortListOrder.list_order = data[i].list_order
                    this.sortLists.push(sortListOrder)
                    sortListOrder = {}
                    if (data[i].children && data[i].children.length > 0) {
                        this.getchangId(data[i].children)
                    }
                }
            },

            listOrder() {
                this.getchangId(this.data)
                orderList(API.link.LIST_ORDER, this.sortLists).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            confirm(row) {
                removeById(API.link.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            start() {
                removeById(API.link.DELE,this.selectedRowKeys).then(res => {
                    if (res == true) {
                        this.getList()
                        this.loading = false;
                        this.selectedRowKeys = [];
                    }
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
          onChange(row) {
            let Json = {id: row.id, status: row.status == 1 ? 2 : 1}
            changStatus(API.link.CHANG_STATUS_FILALE, [Json]).then(res => {
              if (res == true) {
                this.getList()
              }
            })
          },
        },
    }
</script>

<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
